import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

export const RoadWorkReportCompleteTableDataAPI = createAsyncThunk("RoadWorkReportCompleteTableData", async ({ data }) => {
    const {
        M_WardID,
        FromDate,
        ToDate,
        UserID,
        token,
        Flag,
        From,
        To,
        handleGetPdfUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_T_KPI_RM_WorkProgressCompleted_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_UsersID=${UserID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPdfUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const RoadWorkReportCompleteTableDataSlice = createSlice({
    name: "RoadWorkReportCompleteTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoadWorkReportCompleteTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoadWorkReportCompleteTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(RoadWorkReportCompleteTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const RoadWorkReportCompleteTableDataReducer = RoadWorkReportCompleteTableDataSlice.reducer